import {AfterViewInit, Component, Inject} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-app.layout-sales-v3',
  templateUrl: './app.layout-sales-v3.component.html'
})
export class AppLayoutSalesV3Component implements AfterViewInit {
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.svg`;
  showHeader = false;

  constructor(@Inject(DOCUMENT) private document: Document) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'krediya.v3-theme.css';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.showHeader = true;
    }, 400);
  }
}
